import React, { useState } from 'react';
import { toastr } from 'react-redux-toastr';
import { returnToAdminAccount } from '../../../../services/impersonation.service';
import './impersonation-indicator.scss';

interface ImpersonationIndicatorProps {
    email: string;
}

const ImpersonationIndicator: React.FC<ImpersonationIndicatorProps> = ({ email }) => {
    const [isReturning, setIsReturning] = useState(false);

    const onReturn = async () => {
        setIsReturning(true);

        if (await returnToAdminAccount()) {
            window.location.href = '/schedule';
            return;
        }

        setIsReturning(false);
        toastr.error('Error!', 'Could not return to your account. Please log in again.');
    }

    return (
        // The logo block navigates home on click; the indicator must not trigger that.
        <div className="impersonation-indicator" onClick={event => event.stopPropagation()}>
            <span className="impersonation-indicator__text" title={email}>
                <i className="fas fa-user-secret impersonation-indicator__icon" />
                Viewing as <strong>{email}</strong>
            </span>
            <button
                type="button"
                className="impersonation-indicator__return"
                disabled={isReturning}
                onClick={onReturn}>
                {isReturning ? 'Returning...' : 'Return to my account'}
            </button>
        </div>
    );
}

export default ImpersonationIndicator;
